var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { EventTrackerService } from '../../services/event-tracker/event-tracker.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { Channel } from '../../../models/common';
import { InfluencerSetting } from '../../../models/influencer-setting';
import { AuthService } from '../../core/auth.service';
import { Observable } from 'rxjs/Observable';
import { ChannelStatus, CommonConstant, FacebookAuthPreviousState, platformIconPath } from '../../app.constants';
import { Location } from '@angular/common';
import { CampaignService } from '../../services/campaign/campaign.service';
import { ValidationHandlerService } from '../../core/validation-handler.service';
import { NewInfluencerChanel } from '../../../models/influencer/new-influencer';
import { CampaignAcceptionPopupComponent } from '../campaign-acception-popup/campaign-acception-popup.component';
var InfluencerTab;
(function (InfluencerTab) {
    InfluencerTab[InfluencerTab["USER_SETTING"] = 1] = "USER_SETTING";
    InfluencerTab[InfluencerTab["SOCIAL_ACCOUNT"] = 2] = "SOCIAL_ACCOUNT";
})(InfluencerTab || (InfluencerTab = {}));
var InfluencerSettingsComponent = /** @class */ (function (_super) {
    __extends(InfluencerSettingsComponent, _super);
    function InfluencerSettingsComponent(influencerService, activatedRoute, location, auth, campaignService, userService, translateService, modalService, validationError, referenceDataService, eventTracker) {
        var _this = _super.call(this, auth, influencerService, referenceDataService, validationError, activatedRoute, userService, modalService, eventTracker) || this;
        _this.influencerService = influencerService;
        _this.activatedRoute = activatedRoute;
        _this.location = location;
        _this.auth = auth;
        _this.campaignService = campaignService;
        _this.userService = userService;
        _this.translateService = translateService;
        _this.modalService = modalService;
        _this.validationError = validationError;
        _this.referenceDataService = referenceDataService;
        _this.eventTracker = eventTracker;
        _this.platforms = [];
        _this.influencerSetting = new InfluencerSetting();
        // user avatar
        _this.userAvatar = './assets/images/bill-murray.png';
        _this.isAddingChannel = false;
        _this.haveErrorOnAddingNewChannel = false;
        return _this;
    }
    InfluencerSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentInfluencer = this.userService.getInfluencerInfo();
        this.influencerId = this.currentInfluencer.id;
        this.activeTabIndex = InfluencerTab.USER_SETTING;
        this.platforms = this.referenceDataService.platforms;
        this.activePage = FacebookAuthPreviousState.AUTHENTICATED;
        this.initializeInfluencerData();
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.fbAuthError = params.error;
            if (params.error || params.auth_result === 'success') {
                _this.showSocialAccounts();
            }
            _this.loadInfluencerChannels(_this.influencerId, function () {
                if (_this.fbAuthError) {
                    _super.prototype.handleFbAuthOnError.call(_this);
                }
            });
            _super.prototype.intializedChannelListFromLocalData.call(_this);
            _this.auth.removeInfluencerChannelAuthorizationLocalData();
        });
    };
    InfluencerSettingsComponent.prototype.back = function () {
        this.location.back();
    };
    InfluencerSettingsComponent.prototype.initializeInfluencerData = function () {
        var currentUser = this.auth.getUser();
        var currentInfluencer = this.userService.getInfluencerInfo();
        this.influencerSetting.first_name = currentUser.data.firstName;
        this.influencerSetting.last_name = currentUser.data.lastName;
        this.influencerSetting.phone = currentInfluencer.phone;
        this.influencerSetting.email = currentUser.data.email;
        this.influencerSetting.rewrite_email = currentInfluencer.systemEmail;
        this.influencerSetting.avatar = currentInfluencer.profilePicture;
        this.userAvatar = currentInfluencer.profilePicture;
    };
    InfluencerSettingsComponent.prototype.loadInfluencerChannels = function (influencerId, callback) {
        var _this = this;
        this.influencerService.getInfluencerChannels(influencerId).subscribe(function (res) {
            _this.listExistingChannel = res;
            if (callback) {
                callback();
            }
        });
    };
    InfluencerSettingsComponent.prototype.onDismissNotification = function () {
        this.notificationStatus = null;
        this.notificationMessage = null;
    };
    Object.defineProperty(InfluencerSettingsComponent.prototype, "platformBackground", {
        get: function () {
            return this.userService.platformBackground;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerSettingsComponent.prototype.showUserSettings = function () {
        this.activeTabIndex = InfluencerTab.USER_SETTING;
        this.hideSettingAuthorizeBlogBox();
    };
    InfluencerSettingsComponent.prototype.showSocialAccounts = function () {
        this.activeTabIndex = InfluencerTab.SOCIAL_ACCOUNT;
    };
    Object.defineProperty(InfluencerSettingsComponent.prototype, "isActiveUserSettingsTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.USER_SETTING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerSettingsComponent.prototype, "isActiveSocialAccountsTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.SOCIAL_ACCOUNT;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerSettingsComponent.prototype.showSettingAuthorizeBlogBox = function (evt) {
        this.blogChannel = evt;
        this.activeBottomBar = true;
    };
    InfluencerSettingsComponent.prototype.authorizeChannel = function (evt) {
        if (evt.channel === 'blogs') {
            this.showSettingAuthorizeBlogBox(evt.data);
        }
        else {
            _super.prototype.authorizeChannel.call(this, evt);
        }
    };
    InfluencerSettingsComponent.prototype.addNewChannel = function () {
        var _this = this;
        var newInfluencerChannel = new NewInfluencerChanel(this.mobileSelectedChannel, ChannelStatus.UNAUTHORIZE);
        newInfluencerChannel.handle = this.authorizeAccount;
        newInfluencerChannel.influencerId = this.influencerId;
        var selectedPlatform = this.platforms.find(function (p) { return p.id === _this.mobileSelectedChannel; });
        var newChannel = new Channel(0, this.authorizeAccount, ChannelStatus.UNAUTHORIZE, this.influencerId, selectedPlatform);
        newChannel.index = this.newChannelIndex++;
        this.listNewChannel.push(newChannel);
        this.isAddingChannel = true;
        this.closeChannelModal();
        this.influencerService.addChannelByInfluencer(this.influencerId, newInfluencerChannel).subscribe(function (res) {
            _this.showNotificationOnCreateSuccess();
            _this.afterAddingNewAuthorizedChannel(_this.influencerId, false);
        }, function (error) {
            var errorChannelComp = _this.channelComponents.filter(function (c) { return c.channelData.index === newChannel.index; });
            errorChannelComp.forEach(function (c) { return c.platformSetting.status = ChannelStatus.AUTHORIZE_FAILED; });
            var errorCode = error && error.error ? error.error.data : null;
            _this.handleChannelError("new_" + newChannel.index, errorCode);
        });
    };
    InfluencerSettingsComponent.prototype.afterAddingNewAuthorizedChannel = function (influencerId, hasError) {
        var _this = this;
        this.isAddingChannel = false;
        if (hasError) {
            this.listNewChannel = this.listNewChannel.filter(function (c) { return c.id !== 0; });
            this.haveErrorOnAddingNewChannel = true;
        }
        else {
            this.loadInfluencerChannels(influencerId, function () {
                _this.listNewChannel = _this.listNewChannel.filter(function (c) { return c.id !== 0; });
            });
        }
    };
    InfluencerSettingsComponent.prototype.hideSettingAuthorizeBlogBox = function () {
        this.blogChannel = null;
        this.activeBottomBar = false;
    };
    InfluencerSettingsComponent.prototype.addChannel = function () {
        var _this = this;
        this.modalService.openInCenter(this.alertAuthorizeChannel, function () {
            // clear unsave channel data before closing authorization modal
            _this.mobileSelectedChannel = null;
            _this.authorizeAccount = null;
        });
    };
    InfluencerSettingsComponent.prototype.closeChannelModal = function () {
        // clear unsave channel data before closing authorization modal
        this.mobileSelectedChannel = null;
        this.authorizeAccount = null;
        this.modalService.close();
    };
    InfluencerSettingsComponent.prototype.onClose = function () {
        this.modalService.close();
    };
    InfluencerSettingsComponent.prototype.authorizeBlog = function () {
        var _this = this;
        this.blogChannel.type = ChannelStatus.AUTHORIZED;
        this.influencerService.updateInfluencerChannel(this.blogChannel.id, this.blogChannel).subscribe(function (res) {
            _this.loadInfluencerChannels(_this.influencerId);
            _this.hideSettingAuthorizeBlogBox();
        }, function (err) {
            _super.prototype.handleChannelError.call(_this, _this.blogChannel.id, CommonConstant.BLOG_CHANNEL_AUTH_FAIL);
        });
    };
    InfluencerSettingsComponent.prototype.updateSetting = function () {
        var _this = this;
        this.validationError.resetErrors();
        var _a = this.influencerSetting, first_name = _a.first_name, last_name = _a.last_name, email = _a.email, rewrite_email = _a.rewrite_email, phone = _a.phone, avatar = _a.avatar, new_password = _a.new_password, old_password = _a.old_password, repeat_new_password = _a.repeat_new_password;
        var currentInfluencer = this.userService.getInfluencerInfo();
        var domain = currentInfluencer.domain, isActive = currentInfluencer.isActive, pending_completed = currentInfluencer.pending_completed, gender = currentInfluencer.gender, country = currentInfluencer.country, influencerLanguages = currentInfluencer.influencerLanguages;
        var influencerData = {
            id: this.influencerId,
            first_name: first_name, email: email, phone: phone, domain: domain, isActive: isActive, pending_completed: pending_completed, gender: gender,
            profileImage: avatar,
            system_email: rewrite_email,
            country: country.id,
            languages: influencerLanguages.length > 0 ? influencerLanguages.map(function (lang) { return lang.language.id; }) : [CommonConstant.INTERNATIONAL_LANGUAGE]
        };
        var companyId = this.userService.getCompanyId();
        var influencerSettingObservers = [
            this.userService.updateUser(first_name, last_name, email, this.logoImage),
            this.influencerService.updateInfluencerData(this.influencerId, influencerData),
        ];
        if (new_password && old_password) {
            if (repeat_new_password !== new_password) {
                this.validationError.shouldDisplayErrors(true);
                this.validationError.updateErrors([{
                        name: 'repeat_new_password',
                        message: this.translateService.instant('influencer_settings.messages.new_password_not_match')
                    }]);
                return;
            }
            else {
                influencerSettingObservers.push(this.userService.updatePassword(old_password, new_password));
            }
        }
        Observable.forkJoin(influencerSettingObservers).subscribe(function (res) {
            _this.auth.getUserData();
            _this.updateInfluencerData(companyId);
        }, function (err) {
            if (err.error.message === 'Wrong password.') {
                _this.validationError.shouldDisplayErrors(true);
                _this.validationError.updateErrors([{
                        name: 'old_password',
                        message: _this.translateService.instant('influencer_settings.messages.old_password_not_correct')
                    }]);
            }
        });
    };
    InfluencerSettingsComponent.prototype.updateInfluencerData = function (companyId) {
        var _this = this;
        this.userService.loadInfluencerInfoByCompanyId(companyId).subscribe(function (res) {
            _this.userService.addInfluencerInfo(res);
        });
    };
    InfluencerSettingsComponent.prototype.onUserAvatarSelected = function (evt) {
        if (!evt || !evt.target || !evt.target.files) {
            return;
        }
        var selectedImageList = (evt.target.files);
        if (!selectedImageList.length) {
            return;
        }
        this.uploadUserAvatar(selectedImageList[0]);
    };
    Object.defineProperty(InfluencerSettingsComponent.prototype, "isIGChannel", {
        get: function () {
            return this.mobileSelectedChannel
                && (this.mobileSelectedChannel === platformIconPath.instagram.id || this.mobileSelectedChannel === platformIconPath.facebook.id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerSettingsComponent.prototype, "isSelectedChannel", {
        get: function () {
            return this.mobileSelectedChannel;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerSettingsComponent.prototype.showNotificationOnCreateSuccess = function () {
        this.notificationStatus = this.translateService.instant('notification.success');
        this.notificationMessage = this.translateService.instant('influencer_settings.messages.create_channel_success');
        this.modalService.open(this.modifyChannelNotification, this.onDismissNotification.bind(this), true);
    };
    InfluencerSettingsComponent.prototype.uploadUserAvatar = function (logo) {
        var _this = this;
        this.campaignService.validateMaterialUploadFile(logo);
        // Only upload one file on each select
        var formData = new FormData();
        formData.append('file', logo);
        this.campaignService.uploadFile(formData).subscribe(function (data) {
            if (data) {
                _this.influencerSetting.avatar = data.diskFileName;
                _this.userAvatar = data.diskFileName;
            }
        });
    };
    return InfluencerSettingsComponent;
}(CampaignAcceptionPopupComponent));
export { InfluencerSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/influencer-settings.component.ts.pre-build-optimizer.js